import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getBasedIdentityCards: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS,
	},
	getExtendedIdentityCards: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS,
	},
	getFullIdentityCards: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS,
	},
	getIdentityCardsPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS_PREVIEW,
	},
	createIdentityCard:{
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_CARDS].CREATE_IDENTITY_CARD,
	},
	deleteIdentityCard:{
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_CARDS].DELETE_IDENTITY_CARD,
	},
	getIdentityCard:{
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARD,
	},
	patchIdentityCard:{
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_CARDS].PATCH_IDENTITY_CARD,
	}
}
